import Vue from 'vue'
export default {
  install() {
    Vue.mixin({
      methods: {
        // 成功信息提示
        $msg_sus(message, duration = 3000) {
          this.$msg_close()
          this.$message({
            showClose: true,
            message,
            duration,
            type: 'success'
          });
        },

        // 警告信息提示
        $msg_war(message, duration = 3000) {
          this.$msg_close()
          this.$message({
            showClose: true,
            message,
            duration,
            type: 'warning'
          });
        },

        // 错误信息提示
        $msg_err(message, duration = 3000) {
          this.$msg_close()
          this.$message({
            showClose: true,
            message,
            duration,
            type: 'error'
          });
        },

        // 关闭message
        $msg_close() {
          this.$message.closeAll()
        },

        /* 
          1.确认提示框(移动端改)
          2.message：提示信息
          3.confirmButtonText默认值："はい"、cancelButtonText默认值："いいえ"，如需改成其他，直接传参即可
          4.确认时返回true,取消时返回false
        */
        $confirm_hint(message, confirmButtonText = this.$t('COMMON.MSG_DELETE_CONFIRM'), cancelButtonText = this.$t('COMMON.MSG_DELETE_CANCEL')) {
          return new Promise((resolve, reject) => {
            this.$confirm(message, this.$t('COMMON.CONFIRM'), {
              confirmButtonText,
              cancelButtonText,
              type: 'warning',
              center: true,
              showClose: false,
              customClass: 'confirmStyle',
            }).then(() => {
              resolve(true)
            }).catch(() => {
              resolve(false)
            })
          })
        }
      }
    })
  }
}


// WEBPACK FOOTER //
// ./src/common/plugin.js